<template>
</template>

<script>
    import SubscriptionCardsComponent from '../../components/pagesbuilder/dynamic-components/SubscriptionCardsComponent.vue';
    import PreviewComponent from './PreviewComponent.vue';

    export default {
        name: "PreviewSubscriptionCardsComponent",
        mixins: [
            PreviewComponent,
            SubscriptionCardsComponent
        ],
        data () {
            return {
                enableHref: true,
            }
        },
        methods: {
            addListeners() {
                this.componentNode.querySelectorAll('[data-subscription-id]').forEach((el) => {
                    if (el.dataset.subscriptionId) {
                        el.addEventListener('click', () => {
                            location.href = `${window.clientURL}/subscription/${el.dataset.subscriptionId}`
                        });
                    }
                });
            },
            loadMoreClicked () {
                let rows = this.getRows();

                if (rows) {
                    rows++
                } else {
                    rows = 1;
                }

                this.changeMyData({
                    rows
                })
            },
        }
    }
</script>
